package theme

import androidx.compose.ui.graphics.Color

val primaryLight = Color(0xFF116682)
val onPrimaryLight = Color(0xFFFFFFFF)
val primaryContainerLight = Color(0xFFBDE9FF)
val onPrimaryContainerLight = Color(0xFF001F2A)
val secondaryLight = Color(0xFF006A60)
val onSecondaryLight = Color(0xFFFFFFFF)
val secondaryContainerLight = Color(0xFF9EF2E4)
val onSecondaryContainerLight = Color(0xFF00201C)
val tertiaryLight = Color(0xFF006A60)
val onTertiaryLight = Color(0xFFFFFFFF)
val tertiaryContainerLight = Color(0xFF9EF2E4)
val onTertiaryContainerLight = Color(0xFF00201C)
val errorLight = Color(0xFFBA1A1A)
val onErrorLight = Color(0xFFFFFFFF)
val errorContainerLight = Color(0xFFFFDAD6)
val onErrorContainerLight = Color(0xFF410002)
val backgroundLight = Color(0xFFF6FAFD)
val onBackgroundLight = Color(0xFF171C1F)
val surfaceLight = Color(0xFFF6FAFD)
val onSurfaceLight = Color(0xFF171C1F)
val surfaceVariantLight = Color(0xFFDCE4E9)
val onSurfaceVariantLight = Color(0xFF40484C)
val outlineLight = Color(0xFF70787D)
val outlineVariantLight = Color(0xFFC0C8CD)
val scrimLight = Color(0xFF000000)
val inverseSurfaceLight = Color(0xFF2C3134)
val inverseOnSurfaceLight = Color(0xFFEDF1F5)
val inversePrimaryLight = Color(0xFF8BD0EF)
val surfaceDimLight = Color(0xFFD6DBDE)
val surfaceBrightLight = Color(0xFFF6FAFD)
val surfaceContainerLowestLight = Color(0xFFFFFFFF)
val surfaceContainerLowLight = Color(0xFFF0F4F8)
val surfaceContainerLight = Color(0xFFEAEEF2)
val surfaceContainerHighLight = Color(0xFFE4E9EC)
val surfaceContainerHighestLight = Color(0xFFDFE3E7)

val primaryLightMediumContrast = Color(0xFF00495E)
val onPrimaryLightMediumContrast = Color(0xFFFFFFFF)
val primaryContainerLightMediumContrast = Color(0xFF337D99)
val onPrimaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val secondaryLightMediumContrast = Color(0xFF004C44)
val onSecondaryLightMediumContrast = Color(0xFFFFFFFF)
val secondaryContainerLightMediumContrast = Color(0xFF288176)
val onSecondaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val tertiaryLightMediumContrast = Color(0xFF004C44)
val onTertiaryLightMediumContrast = Color(0xFFFFFFFF)
val tertiaryContainerLightMediumContrast = Color(0xFF288176)
val onTertiaryContainerLightMediumContrast = Color(0xFFFFFFFF)
val errorLightMediumContrast = Color(0xFF8C0009)
val onErrorLightMediumContrast = Color(0xFFFFFFFF)
val errorContainerLightMediumContrast = Color(0xFFDA342E)
val onErrorContainerLightMediumContrast = Color(0xFFFFFFFF)
val backgroundLightMediumContrast = Color(0xFFF6FAFD)
val onBackgroundLightMediumContrast = Color(0xFF171C1F)
val surfaceLightMediumContrast = Color(0xFFF6FAFD)
val onSurfaceLightMediumContrast = Color(0xFF171C1F)
val surfaceVariantLightMediumContrast = Color(0xFFDCE4E9)
val onSurfaceVariantLightMediumContrast = Color(0xFF3C4448)
val outlineLightMediumContrast = Color(0xFF586065)
val outlineVariantLightMediumContrast = Color(0xFF747C80)
val scrimLightMediumContrast = Color(0xFF000000)
val inverseSurfaceLightMediumContrast = Color(0xFF2C3134)
val inverseOnSurfaceLightMediumContrast = Color(0xFFEDF1F5)
val inversePrimaryLightMediumContrast = Color(0xFF8BD0EF)
val surfaceDimLightMediumContrast = Color(0xFFD6DBDE)
val surfaceBrightLightMediumContrast = Color(0xFFF6FAFD)
val surfaceContainerLowestLightMediumContrast = Color(0xFFFFFFFF)
val surfaceContainerLowLightMediumContrast = Color(0xFFF0F4F8)
val surfaceContainerLightMediumContrast = Color(0xFFEAEEF2)
val surfaceContainerHighLightMediumContrast = Color(0xFFE4E9EC)
val surfaceContainerHighestLightMediumContrast = Color(0xFFDFE3E7)

val primaryLightHighContrast = Color(0xFF002633)
val onPrimaryLightHighContrast = Color(0xFFFFFFFF)
val primaryContainerLightHighContrast = Color(0xFF00495E)
val onPrimaryContainerLightHighContrast = Color(0xFFFFFFFF)
val secondaryLightHighContrast = Color(0xFF002823)
val onSecondaryLightHighContrast = Color(0xFFFFFFFF)
val secondaryContainerLightHighContrast = Color(0xFF004C44)
val onSecondaryContainerLightHighContrast = Color(0xFFFFFFFF)
val tertiaryLightHighContrast = Color(0xFF002823)
val onTertiaryLightHighContrast = Color(0xFFFFFFFF)
val tertiaryContainerLightHighContrast = Color(0xFF004C44)
val onTertiaryContainerLightHighContrast = Color(0xFFFFFFFF)
val errorLightHighContrast = Color(0xFF4E0002)
val onErrorLightHighContrast = Color(0xFFFFFFFF)
val errorContainerLightHighContrast = Color(0xFF8C0009)
val onErrorContainerLightHighContrast = Color(0xFFFFFFFF)
val backgroundLightHighContrast = Color(0xFFF6FAFD)
val onBackgroundLightHighContrast = Color(0xFF171C1F)
val surfaceLightHighContrast = Color(0xFFF6FAFD)
val onSurfaceLightHighContrast = Color(0xFF000000)
val surfaceVariantLightHighContrast = Color(0xFFDCE4E9)
val onSurfaceVariantLightHighContrast = Color(0xFF1D2529)
val outlineLightHighContrast = Color(0xFF3C4448)
val outlineVariantLightHighContrast = Color(0xFF3C4448)
val scrimLightHighContrast = Color(0xFF000000)
val inverseSurfaceLightHighContrast = Color(0xFF2C3134)
val inverseOnSurfaceLightHighContrast = Color(0xFFFFFFFF)
val inversePrimaryLightHighContrast = Color(0xFFD5F0FF)
val surfaceDimLightHighContrast = Color(0xFFD6DBDE)
val surfaceBrightLightHighContrast = Color(0xFFF6FAFD)
val surfaceContainerLowestLightHighContrast = Color(0xFFFFFFFF)
val surfaceContainerLowLightHighContrast = Color(0xFFF0F4F8)
val surfaceContainerLightHighContrast = Color(0xFFEAEEF2)
val surfaceContainerHighLightHighContrast = Color(0xFFE4E9EC)
val surfaceContainerHighestLightHighContrast = Color(0xFFDFE3E7)

val primaryDark = Color(0xFF74A7FF)
val onPrimaryDark = Color(0xFF00247C)
val primaryContainerDark = Color(0xFF00247C)
val onPrimaryContainerDark = Color(0xFFE7F0FF)
val secondaryDark = Color(0xFF82D5C8)
val onSecondaryDark = Color(0xFF003731)
val secondaryContainerDark = Color(0xFF00247C)
val onSecondaryContainerDark = Color(0xFFE7F0FF)
val tertiaryDark = Color(0xFF82D5C8)
val onTertiaryDark = Color(0xFF003731)
val tertiaryContainerDark = Color(0xFF00247C)
val onTertiaryContainerDark = Color(0xFFE7F0FF)
val errorDark = Color(0xFFFFB4AB)
val onErrorDark = Color(0xFF690005)
val errorContainerDark = Color(0xFF93000A)
val onErrorContainerDark = Color(0xFFFFDAD6)
val backgroundDark = Color(0xFF0F1417)
val onBackgroundDark = Color(0xFFDFE3E7)
val surfaceDark = Color(0xFF0F1417)
val onSurfaceDark = Color(0xFFDFE3E7)
val surfaceVariantDark = Color(0xFF40484C)
val onSurfaceVariantDark = Color(0xFFC0C8CD)
val outlineDark = Color(0xFF8A9297)
val outlineVariantDark = Color(0xFF40484C)
val scrimDark = Color(0xFF000000)
val inverseSurfaceDark = Color(0xFFDFE3E7)
val inverseOnSurfaceDark = Color(0xFF2C3134)
val inversePrimaryDark = Color(0xFF2F5FC0)
val surfaceDimDark = Color(0xFF0F1417)
val surfaceBrightDark = Color(0xFF353A3D)
val surfaceContainerLowestDark = Color(0xFF0A0F11)
val surfaceContainerLowDark = Color(0xFF171C1F)
val surfaceContainerDark = Color(0xFF1B2023)
val surfaceContainerHighDark = Color(0xFF262B2D)
val surfaceContainerHighestDark = Color(0xFF303538)

val primaryDarkMediumContrast = Color(0xFF8FD4F3)
val onPrimaryDarkMediumContrast = Color(0xFF001923)
val primaryContainerDarkMediumContrast = Color(0xFF5399B7)
val onPrimaryContainerDarkMediumContrast = Color(0xFF000000)
val secondaryDarkMediumContrast = Color(0xFF86DACC)
val onSecondaryDarkMediumContrast = Color(0xFF001A17)
val secondaryContainerDarkMediumContrast = Color(0xFF4A9E93)
val onSecondaryContainerDarkMediumContrast = Color(0xFF000000)
val tertiaryDarkMediumContrast = Color(0xFF86DACC)
val onTertiaryDarkMediumContrast = Color(0xFF001A17)
val tertiaryContainerDarkMediumContrast = Color(0xFF4A9E93)
val onTertiaryContainerDarkMediumContrast = Color(0xFF000000)
val errorDarkMediumContrast = Color(0xFFFFBAB1)
val onErrorDarkMediumContrast = Color(0xFF370001)
val errorContainerDarkMediumContrast = Color(0xFFFF5449)
val onErrorContainerDarkMediumContrast = Color(0xFF000000)
val backgroundDarkMediumContrast = Color(0xFF0F1417)
val onBackgroundDarkMediumContrast = Color(0xFFDFE3E7)
val surfaceDarkMediumContrast = Color(0xFF0F1417)
val onSurfaceDarkMediumContrast = Color(0xFFF7FBFF)
val surfaceVariantDarkMediumContrast = Color(0xFF40484C)
val onSurfaceVariantDarkMediumContrast = Color(0xFFC4CCD1)
val outlineDarkMediumContrast = Color(0xFF9CA4A9)
val outlineVariantDarkMediumContrast = Color(0xFF7C8489)
val scrimDarkMediumContrast = Color(0xFF000000)
val inverseSurfaceDarkMediumContrast = Color(0xFFDFE3E7)
val inverseOnSurfaceDarkMediumContrast = Color(0xFF262B2E)
val inversePrimaryDarkMediumContrast = Color(0xFF004E65)
val surfaceDimDarkMediumContrast = Color(0xFF0F1417)
val surfaceBrightDarkMediumContrast = Color(0xFF353A3D)
val surfaceContainerLowestDarkMediumContrast = Color(0xFF0A0F11)
val surfaceContainerLowDarkMediumContrast = Color(0xFF171C1F)
val surfaceContainerDarkMediumContrast = Color(0xFF1B2023)
val surfaceContainerHighDarkMediumContrast = Color(0xFF262B2D)
val surfaceContainerHighestDarkMediumContrast = Color(0xFF303538)

val primaryDarkHighContrast = Color(0xFFF7FBFF)
val onPrimaryDarkHighContrast = Color(0xFF000000)
val primaryContainerDarkHighContrast = Color(0xFF8FD4F3)
val onPrimaryContainerDarkHighContrast = Color(0xFF000000)
val secondaryDarkHighContrast = Color(0xFFEBFFFA)
val onSecondaryDarkHighContrast = Color(0xFF000000)
val secondaryContainerDarkHighContrast = Color(0xFF86DACC)
val onSecondaryContainerDarkHighContrast = Color(0xFF000000)
val tertiaryDarkHighContrast = Color(0xFFEBFFFA)
val onTertiaryDarkHighContrast = Color(0xFF000000)
val tertiaryContainerDarkHighContrast = Color(0xFF86DACC)
val onTertiaryContainerDarkHighContrast = Color(0xFF000000)
val errorDarkHighContrast = Color(0xFFFFF9F9)
val onErrorDarkHighContrast = Color(0xFF000000)
val errorContainerDarkHighContrast = Color(0xFFFFBAB1)
val onErrorContainerDarkHighContrast = Color(0xFF000000)
val backgroundDarkHighContrast = Color(0xFF0F1417)
val onBackgroundDarkHighContrast = Color(0xFFDFE3E7)
val surfaceDarkHighContrast = Color(0xFF0F1417)
val onSurfaceDarkHighContrast = Color(0xFFFFFFFF)
val surfaceVariantDarkHighContrast = Color(0xFF40484C)
val onSurfaceVariantDarkHighContrast = Color(0xFFF7FBFF)
val outlineDarkHighContrast = Color(0xFFC4CCD1)
val outlineVariantDarkHighContrast = Color(0xFFC4CCD1)
val scrimDarkHighContrast = Color(0xFF000000)
val inverseSurfaceDarkHighContrast = Color(0xFFDFE3E7)
val inverseOnSurfaceDarkHighContrast = Color(0xFF000000)
val inversePrimaryDarkHighContrast = Color(0xFF002E3D)
val surfaceDimDarkHighContrast = Color(0xFF0F1417)
val surfaceBrightDarkHighContrast = Color(0xFF353A3D)
val surfaceContainerLowestDarkHighContrast = Color(0xFF0A0F11)
val surfaceContainerLowDarkHighContrast = Color(0xFF171C1F)
val surfaceContainerDarkHighContrast = Color(0xFF1B2023)
val surfaceContainerHighDarkHighContrast = Color(0xFF262B2D)
val surfaceContainerHighestDarkHighContrast = Color(0xFF303538)


val ColorMaterialBlue500 = Color(0xFF2196F3)
val ColorMaterialGreen500 = Color(0xFF43A047)
val ColorMaterialOrange500 = Color(0xFFFF9800)
val ColorMaterialViolet500 = Color(0xFF673AB7)
val ColorMaterialRed500 = Color(0xFFF44336)





